import { getIndex } from './excelColumns';
import { RowType } from '../order/removeRowsWithoutOrder';

export default <T>(neededColumns: T[], data: RowType[][], allColumns: T[]): string[][] => {
    const indexes = getIndex<T>(neededColumns, allColumns);
    return data.reduce((result: string[][], current: string[]) => {
        return [...result, current.filter((_, i) => indexes.indexOf(i) !== -1)];
    }, []);
};



// WEBPACK FOOTER //
// ./src/view/common/extractOnlyNeededColumns.ts